export default __webpack_public_path__ + "static/media/mock_parvo.a6e04348.png";